export default [
  { name: 'Eng', code: 'en', iso: 'en-US', file: './i18n/translations/en' },
  { name: 'Rus', code: 'ru', iso: 'ru-RU', file: './i18n/translations/ru' },
]
